import { render, staticRenderFns } from "./detailTabLampiran.vue?vue&type=template&id=ead5510c"
import script from "./detailTabLampiran.vue?vue&type=script&lang=js"
export * from "./detailTabLampiran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports